import { render, staticRenderFns } from "./ModalVerifikasiTerblokir.vue?vue&type=template&id=7b2682d5&"
import script from "./ModalVerifikasiTerblokir.vue?vue&type=script&lang=js&"
export * from "./ModalVerifikasiTerblokir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports